import $ from "jquery";
import util from "../util";
import { setIndexInGroup } from "./group";
import Text from "./text";
import { updatePageBars } from "./selection";
import { adjustAfterPageResize } from "./reposition-frame";
import MenuObject, { setInitColors } from "./menu-object";
import renderer from "./renderer";
import store from "../store";
import * as actions from "../actions";
import Interactable from "./interactable";
import { setLineHeights } from "./line-height";
import menuObject from "./menu-object";
import constants from "../constants";

export const SELECTOR_ALL_COMPONENTS = 'div.page .content [data-component]';

export function ensureFrameDimensions($frame, height) {
  const ratio = parseFloat($frame.attr('data-custom-ratio') || $frame.attr('data-ratio'));
  const newFrameHeight = $frame.width() / ratio;
  $frame.css('height', `${util.pixelToPercent(newFrameHeight, height)}%`);
}

export function ensureImageDimensions($img, height) {
  const ratio = parseFloat($img.attr('data-temp-ratio') || $img.attr('data-custom-ratio') || $img.attr('data-ratio'));
  $img.removeAttr('data-temp-ratio');
  const newImgHeight = $img.width() / ratio;
  $img.css('height', `${util.pixelToPercent(newImgHeight, height)}%`);
}

export function ensureGroupDimensions($element) {
  const elHeight = Math.round($element.height());
  const elHeightInGroup = parseInt($element.attr('data-height-in-group'), 10);

  const $group = $element.parents('.group');

  if (elHeight !== elHeightInGroup) {
    $element.attr('data-height-in-group', elHeight);

    const $kids = $group.children('.comp, .frame, .image, .qr, .menu-object');
    setIndexInGroup($kids);

    const heightDif = elHeight - elHeightInGroup;
    const currentIdxInGroup = parseInt($element.attr('data-idx-in-group'), 10);

    let newHeight = 0;
    $kids.each(function () {
      const $kid = $(this);
      let kidHeight = $kid.position().top + $kid.height();

      if (currentIdxInGroup < parseInt($kid.attr('data-idx-in-group'), 10)) {
        kidHeight += heightDif;
      }

      if (kidHeight > newHeight) {
        newHeight = kidHeight;
      }
    });

    $kids.each(function () {
      const $kid = $(this);

      const idxInGroup = parseInt($kid.attr('data-idx-in-group'), 10);
      let elTop = Math.round(parseFloat($kid.css('top')));

      if (idxInGroup > currentIdxInGroup) elTop += heightDif;
      $kid.attr('data-top-in-group', elTop);

      $kid.css('top', `${util.pixelToPercent(elTop, newHeight)}%`);

      if (util.isFrame($kid)) {
        ensureFrameDimensions($kid, newHeight);
      } else if (util.isImage($kid)) {
        ensureImageDimensions($kid, newHeight);
      }
    });

    $group.css('height', `${util.pixelToPercent(newHeight, util.getActiveDimensions().height)}%`);
    updatePageBars($group);
  }
}

export function fixDimensionsAfterResize() {
  $('[data-component="text"]').each(function () {
    Text.ensureTextSize($(this));
  });

  $('[data-component="image"]').each(function () {
    const $this = $(this);
    ensureImageDimensions($this, $this.parents('.page').height());
  });

  $('[data-component="shape"]').each(function () {
    const $this = $(this);
    ensureImageDimensions($this, $this.parents('.page').height());
  });

  $('[data-component="frame"]').each(function () {
    const $this = $(this);
    if ($this.attr('data-full-page') === 'true') return;
    ensureImageDimensions($this, $this.parents('.page').height());
    adjustAfterPageResize($this);
  });

  $('[data-component="qr-code"]').each(function () {
    const $this = $(this);
    ensureImageDimensions($this, $this.parents('.page').height());
  });

  $('[data-component="menu-object"]').each(function () {
    const $this = $(this);
    MenuObject.fixNameNotesPadding($this);
    MenuObject.fixHeightWithColumns($this);
  });

  if (util.getActiveDimensions().unit === 'in') {
    $('[data-inch-width]').each(function () {
      const $element = $(this);
      $element.attr('data-inch-width', util.pixelToInch($element.width()));
    });

    $('[data-inch-height]').each(function () {
      const $element = $(this);
      $element.attr('data-inch-height', util.pixelToInch($element.height()));
    });
  }
}

export function fixPositionForTakeoutResize(size, oldSize) {
  console.log("> size: " + size);
  console.log("> oldSize: " + oldSize);

  const fold = size.folds[0];

  const $components = $(SELECTOR_ALL_COMPONENTS);
  console.log("-> $components.length: " + $components.length);

  console.log("-> size.width: " + size.width);
  console.log("-> size.height: " + size.height);

  const dims = util.getActiveDimensions();
  const pageHeight = dims.height;
  const pageWidth = dims.width;

  let foldOne = fold.foldOne ? util.inchToPercent(fold.foldOne, pageWidth) : null;
  let foldTwo = fold.foldTwo ? util.inchToPercent(fold.foldTwo, pageWidth) : null;
  let foldThree = fold.foldThree ? util.inchToPercent(fold.foldThree, pageWidth) : null;
  let panels = fold.foldThree ? 4 : fold.foldTwo ? 3 : 2;
  const panelsWidth = dims.width / panels;

  console.log("-> fold 1: " + foldOne);
  console.log("-> fold 2: " + foldTwo);
  console.log("-> fold 3: " + foldThree);

  const gutter = 3;
  const gutterPx = util.percentToPixel(gutter, pageWidth);
  const topGutter = 8;

  $('.page').each(function (i) {
    // Initialize top positions for each panel
    const topPositions = [topGutter, topGutter, topGutter, topGutter];

    // Background color
    const bgColor = this.style.backgroundColor;
    console.log("Background color: " + bgColor);

    const grayTextColor = "#7d7f7c";

    // Texts
    const $texts = $(this).find(`[data-component="text"]`);
    const textsPerPanel = $texts.length / panels;

    // Identify the text with the largest font size
    let largestFontSize = 0;
    let largestTextElement = null;
    $texts.each(function () {
      const fontSize = parseInt($(this).find('p').css('font-size'), 10);
      if (fontSize > largestFontSize) {
        largestFontSize = fontSize;
        largestTextElement = this;
      }
    });

    console.log("Largest font size: " + largestFontSize);

    // Place the largest text at the top of its panel
    if (largestTextElement) {
      renderer.unlock($(largestTextElement));
      largestTextElement.style.left = `${foldTwo + gutter}%`;
      largestTextElement.style.top = `${util.pixelToPercent(topGutter, pageHeight)}%`
      const newWidth = panelsWidth - (gutterPx * 2);
      largestTextElement.style.width = `${newWidth}px`;
      $(largestTextElement).find('.wrapper').css({ 'width': `${newWidth}px` });
      topPositions[2] += $(largestTextElement)[0].getBoundingClientRect().height;

      try {
        if (bgColor === largestTextElement.style.color) {
          largestTextElement.style.color = grayTextColor;
        }
      } catch (e) {
        console.log(e);
      }
    }

    // Place the remaining texts
    $texts.each(function (i) {
      if (this !== largestTextElement) {
        renderer.unlock($(this));

        try {
          if (bgColor === this.style.color) {
            this.style.color = grayTextColor;
          }
        } catch (e) {
          console.log(e);
        }

        let panelIndex = Math.floor(i / textsPerPanel);
        if (panelIndex === 0) {
          this.style.left = `${gutter}%`;
        } else if (panelIndex === 1) {
          this.style.left = `${foldOne + gutter}%`;
        } else if (panelIndex === 2) {
          this.style.left = `${foldTwo + gutter}%`;
        }

        const newWidth = panelsWidth - (gutterPx * 2);
        this.style.width = `${newWidth}px`;
        $(this).find('.wrapper').css({ 'width': `${newWidth}px` });

        // Set the top position
        let topPosition = topPositions[panelIndex];
        if (topPosition + $(this).height() > pageHeight) {
          topPosition = pageHeight - $(this).height();
        }
        this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

        // Update the top position for the next element in the same panel
        topPositions[panelIndex] += $(this).height() + topGutter;
      }
    });

    // Menu Objects
    const $menuObjects = $(this).find(`[data-component="menu-object"]`);
    const mosPerPanel = $menuObjects.length / panels;

    $menuObjects.each(function (i) {
      renderer.unlock($(this));

      try {
        // Adjust color if text is the same color as the page background
        const styles = MenuObject.getStyles($(this));
        const itemNameColor = styles && styles['name'] ? styles['name'].color : '';
        const itemPriceColor = styles && styles['price-entry'] ? styles['price-entry'].color : '';
        const groupNameColor = styles && styles['mo-name'] ? styles['mo-name'].color : '';
        const groupNotesColor = styles && styles['mo-notes'] ? styles['mo-notes'].color : '';

        if (util.compareColors(bgColor, itemNameColor) ||
          util.compareColors(bgColor, itemPriceColor) ||
          util.compareColors(bgColor, groupNameColor) ||
          util.compareColors(bgColor, groupNotesColor)) {
          const $mo = $(this);

          ['name', 'tag', 'description', 'price', 'extras', 'price-entry', 'mo-name', 'mo-notes'].forEach(function (cat) {
            MenuObject.patchStyles($mo, {
              type: cat,
              key: 'color',
              value: grayTextColor
            }, false, false);
          })
        }
      } catch (e) {
        console.log(e);
      }

      let panelIndex = Math.floor(i / mosPerPanel);
      if (panelIndex === 0) {
        this.style.left = `${gutter}%`;
      } else if (panelIndex === 1) {
        this.style.left = `${foldOne + gutter}%`;
      } else if (panelIndex === 2) {
        this.style.left = `${foldTwo + gutter}%`;
      }

      const newWidth = panelsWidth - (gutterPx * 2);
      this.style.width = `${newWidth}px`;
      $(this).find('.wrapper').css({ 'width': `${newWidth}px` });

      // Set the top position
      let topPosition = topPositions[panelIndex];
      if (topPosition + $(this).height() > pageHeight) {
        topPosition = pageHeight - $(this).height();
      }
      this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      store.dispatch(actions.select($(this)));

      if (panels > 2) {
        MenuObject.setColumns($(this), 1);
      }
      MenuObject.fixLineHeights($(this), true);

      // Update the top position for the next element in the same panel
      topPositions[panelIndex] += $(this).height() + topGutter;
    });

    // Frames and Images
    const $framesAndImages = $(this).find(`[data-component="frame"], [data-component="image"]`);
    const widthScalingFactor = panelsWidth / util.inchToPixel(oldSize.width);

    $framesAndImages.each(function (i) {
      renderer.unlock($(this));

      const $this = $(this);
      if (this.style.width !== "100%" && this.style.height !== "100%") {
        let panelIndex = Math.floor(i / ($framesAndImages.length / panels));
        if (panelIndex === 0) {
          this.style.left = `${gutter}%`;
        } else if (panelIndex === 1) {
          this.style.left = `${foldOne + gutter}%`;
        } else if (panelIndex === 2) {
          this.style.left = `${foldTwo + gutter}%`;
        }

        const originalWidth = $this.width();
        const originalHeight = $this.height();
        let newWidth = originalWidth * widthScalingFactor;
        newWidth = Math.min(newWidth, panelsWidth - (gutterPx * 2));
        const aspectRatio = originalHeight / originalWidth;
        const newHeight = newWidth * aspectRatio;

        this.style.width = `${newWidth}px`;
        this.style.height = `${newHeight}px`;
        $(this).find('.wrapper').css({
          'width': `${newWidth}px`,
          'height': `${newHeight}px`
        });

        // Set the top position
        let topPosition = topPositions[panelIndex];
        if (topPosition + $(this).height() > pageHeight) {
          topPosition = pageHeight - $(this).height();
        }
        this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

        // Update the top position for the next element in the same panel
        topPositions[panelIndex] += $(this).height() + topGutter;
      }
    });

    // Shapes
    const $shapes = $(this).find(`[data-component="shape"]`);
    $shapes.each(function (i) {
      renderer.unlock($(this));

      let panelIndex = Math.floor(i / ($shapes.length / panels));
      if (panelIndex === 0) {
        this.style.left = `${gutter}%`;
      } else if (panelIndex === 1) {
        this.style.left = `${foldOne + gutter}%`;
      } else if (panelIndex === 2) {
        this.style.left = `${foldTwo + gutter}%`;
      }

      // const originalWidth = $(this).width();
      // const originalHeight = $(this).height();
      // let newWidth = originalWidth * widthScalingFactor;
      // newWidth = Math.min(newWidth, panelsWidth - (gutterPx * 2));
      // const aspectRatio = originalHeight / originalWidth;
      // const newHeight = newWidth * aspectRatio;

      // this.style.width = `${newWidth}px`;
      // this.style.height = `${newHeight}px`;
      // $(this).find('.wrapper').css({
      //   'width': `${newWidth}px`,
      //   'height': `${newHeight}px`
      // });
      // $(this).attr("data-px-width", newWidth);

      // Set the top position
      let topPosition = topPositions[panelIndex];
      if (topPosition + $(this).height() > pageHeight) {
        topPosition = pageHeight - $(this).height();
      }
      this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      // Update the top position for the next element in the same panel
      topPositions[panelIndex] += $(this).height() + topGutter;
    });

    // Illustrations
    const $illustrations = $(this).find(`[data-component="illustration"]`);
    $illustrations.each(function (i) {
      renderer.unlock($(this));

      let panelIndex = Math.floor(i / ($illustrations.length / panels));
      if (panelIndex === 0) {
        this.style.left = `${gutter}%`;
      } else if (panelIndex === 1) {
        this.style.left = `${foldOne + gutter}%`;
      } else if (panelIndex === 2) {
        this.style.left = `${foldTwo + gutter}%`;
      }

      const originalWidth = $(this).width();
      const originalHeight = $(this).height();
      let newWidth = originalWidth * widthScalingFactor;
      newWidth = Math.min(newWidth, panelsWidth - (gutterPx * 2));
      const aspectRatio = originalHeight / originalWidth;
      const newHeight = newWidth * aspectRatio;

      this.style.width = `${newWidth}px`;
      this.style.height = `${newHeight}px`;
      $(this).find('.wrapper').css({
        'width': `${newWidth}px`,
        'height': `${newHeight}px`
      });
      $(this).attr("data-px-width", newWidth);

      // Set the top position
      let topPosition = topPositions[panelIndex];
      if (topPosition + $(this).height() > pageHeight) {
        topPosition = pageHeight - $(this).height();
      }
      this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      // Update the top position for the next element in the same panel
      topPositions[panelIndex] += $(this).height() + topGutter;
    });

    util.nextTick(() => {
      $components.each(function (i) {
        Interactable.of($(this)).refreshPosition();
      });
    });
  });
}

export function fixPositionForTableTentResize(size, oldSize) {
  console.log("> size: " + size);
  console.log("> oldSize: " + oldSize);

  const $components = $(SELECTOR_ALL_COMPONENTS);
  console.log("-> $components.length: " + $components.length);

  console.log("-> size.width: " + size.width);
  console.log("-> size.height: " + size.height);

  const dims = util.getActiveDimensions();
  const pageHeight = dims.height;
  const pageWidth = dims.width;

  const gutter = 3;
  const gutterPx = util.percentToPixel(gutter, pageWidth);

  const widthScalingFactorInch = size.width / oldSize.width;

  $('.page').each(function (i) {
    // Menu Objects
    const $menuObjects = $(this).find(`[data-component="menu-object"]`);

    $menuObjects.each(function (i) {
      const newWidth = pageWidth - (gutterPx * 2);
      this.style.left = `${gutter}%`;
      this.style.width = `${newWidth}px`;
      $(this).find('.wrapper').css({ 'width': `${newWidth}px` });
    });

    // Texts
    const $texts = $(this).find(`[data-component="text"]`);

    $texts.each(function (i) {
      const $this = $(this);
      const originalWidth = $this.width();
      // const newWidth = originalWidth * widthScalingFactorInch - (gutterPx * 2);
      const newWidth = pageWidth - (gutterPx * 2);
      this.style.left = `${gutter}%`;
      this.style.width = `${newWidth}px`;
      $this.find('.wrapper').css({ 'width': `${newWidth}px` });

      // Calculate the new font size
      const originalFontSize = parseFloat($this.css('font-size'));
      const newFontSize = originalFontSize * widthScalingFactorInch;

      const dims = renderer.getDimensions();
      if (dims.unit === 'in') {
        const pixels = util.getPointsInPixels(newFontSize, dims);
        const percent = util.pixelToPercent(pixels, dims.fontSize);
        // renderer.updateElementStyle($this, 'fontSize', `${percent}%`, { fontSize: newFontSize });

        $this.find('p').each(function () {
          const $p = $(this);
          $p.css('font-size', `${percent}%`);
          setLineHeights($this);
        });

      } else {
        const percent = newFontSize * constants.PIXEL_FONT_SIZE_ADJUSTMENT;

        $this.find('p').each(function () {
          const $p = $(this);
          $p.css('font-size', `${percent}%`);
          setLineHeights($this);
        });

        // renderer.updateElementStyle($this, 'fontSize', `${percent}%`, { fontSize: newFontSize });
      }
    });


    // Frames and Images
    const $framesAndImages = $(this).find(`[data-component="frame"], [data-component="image"]`);
    const widthScalingFactor = pageWidth / util.inchToPixel(oldSize.width);

    $framesAndImages.each(function (i) {
      const $this = $(this);

      if (this.style.width !== "100%" && this.style.height !== "100%") {
        // Calculate the new width
        const originalWidth = $this.width();
        const originalHeight = $this.height();
        let newWidth = originalWidth * widthScalingFactor;

        // Ensure the new width does not exceed panelsWidth
        newWidth = Math.min(newWidth, pageWidth - (gutterPx * 2));

        // Calculate the new height based on the aspect ratio
        const aspectRatio = originalHeight / originalWidth;
        const newHeight = newWidth * aspectRatio;

        this.style.left = `${gutter}%`;
        this.style.width = `${newWidth}px`;
        this.style.height = `${newHeight}px`;

        // Apply the new width and height to the wrapper
        $this.find('.wrapper').css({
          'width': `${newWidth}px`,
          'height': `${newHeight}px`
        });
      }
    });


    // Shapes and Illustrations
    const $shapesAndIllustrations = $(this).find(`[data-component="shape"], [data-component="illustration"]`);

    $shapesAndIllustrations.each(function (i) {
      // this.style.top = `${gutter}%`;
      const newWidth = pageWidth - (gutterPx * 2);
      this.style.left = `${gutter}%`;
      this.style.width = `${newWidth}px`;
      $(this).attr("data-px-width", newWidth);
      // $(this).find('.wrapper').css({ 'width': `${newWidth}px` });
    });
  });
}

export function fixPositionForMenuResize(size, oldSize) {
  console.log("> size: " + size);
  console.log("> oldSize: " + oldSize);

  const $components = $(SELECTOR_ALL_COMPONENTS);
  console.log("-> $components.length: " + $components.length);

  console.log("-> size.width: " + size.width);
  console.log("-> size.height: " + size.height);

  const dims = util.getActiveDimensions();
  const pageHeight = dims.height;
  const pageWidth = dims.width;

  const gutter = 3;
  const gutterPx = util.percentToPixel(gutter, pageWidth);
  const topGutter = 8;

  $('.page').each(function (i) {
    // Initialize top positions
    // const topPositions = [topGutter, topGutter, topGutter, topGutter];

    // Background color
    const bgColor = this.style.backgroundColor;
    console.log("Background color: " + bgColor);

    const grayTextColor = "#7d7f7c";

    // Texts
    const $texts = $(this).find(`[data-component="text"]`);

    // Identify the text with the largest font size
    let largestFontSize = 0;
    let largestTextElement = null;
    $texts.each(function () {
      const fontSize = parseInt($(this).find('p').css('font-size'), 10);
      if (fontSize > largestFontSize) {
        largestFontSize = fontSize;
        largestTextElement = this;
      }
    });

    console.log("Largest font size: " + largestFontSize);

    // Place the largest text at the top center of the page
    if (largestTextElement) {
      renderer.unlock($(largestTextElement));
      largestTextElement.style.left = `50%`;
      largestTextElement.style.transform = `translateX(-50%)`;
      largestTextElement.style.top = `${util.pixelToPercent(topGutter, pageHeight)}%`;
      // const newWidth = pageWidth - (gutterPx * 2);
      // largestTextElement.style.width = `${newWidth}px`;
      // $(largestTextElement).find('.wrapper').css({ 'width': `${newWidth}px` });
      // topPositions[2] += $(largestTextElement)[0].getBoundingClientRect().height;

      try {
        if (bgColor === largestTextElement.style.color) {
          largestTextElement.style.color = grayTextColor;
        }
      } catch (e) {
        console.log(e);
      }
    }

    // Place the remaining texts
    $texts.each(function (i) {
      if (this !== largestTextElement) {
        renderer.unlock($(this));

        try {
          if (bgColor === this.style.color) {
            this.style.color = grayTextColor;
          }
        } catch (e) {
          console.log(e);
        }

        this.style.left = `${gutter}%`;

        const newWidth = pageWidth - (gutterPx * 2);
        this.style.width = `${newWidth}px`;
        $(this).find('.wrapper').css({ 'width': `${newWidth}px` });

        // Set the top position
        // let topPosition = topPositions[panelIndex];
        // if (topPosition + $(this).height() > pageHeight) {
        //   topPosition = pageHeight - $(this).height();
        // }
        // this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

        // Update the top position for the next element in the same panel
        // topPositions[panelIndex] += $(this).height() + topGutter;
      }
    });

    // Menu Objects
    const $menuObjects = $(this).find(`[data-component="menu-object"]`);
    // const mosPerPanel = $menuObjects.length / panels;

    $menuObjects.each(function (i) {
      renderer.unlock($(this));

      const $mo = $(this);

      ['name', 'tag', 'description', 'price', 'extras', 'price-entry', 'mo-name', 'mo-notes'].forEach(function (cat) {
        const moStyles = MenuObject.getStyles($mo)[cat];

        if (moStyles) {
          const currentFontSize = moStyles['font-size'] ? parseFloat(moStyles['font-size']) : 100;
          const newFontSize = currentFontSize * 0.8;

          MenuObject.patchStyles($mo, {
            type: cat,
            key: 'font-size',
            value: `${newFontSize}%`
          }, false, false);
        }
      })

      try {
        // Adjust color if text is the same color as the page background
        const styles = MenuObject.getStyles($(this));
        const itemNameColor = styles && styles['name'] ? styles['name'].color : '';
        // const itemPriceColor = styles && styles['price-entry'] ? styles['price-entry'].color : '';
        const groupNameColor = styles && styles['mo-name'] ? styles['mo-name'].color : '';
        const groupNotesColor = styles && styles['mo-notes'] ? styles['mo-notes'].color : '';

        if (util.compareColors(bgColor, itemNameColor) ||
          // util.compareColors(bgColor, itemPriceColor) ||
          util.compareColors(bgColor, groupNameColor) ||
          util.compareColors(bgColor, groupNotesColor)) {
          const $mo = $(this);

          ['name', 'tag', 'description', 'price', 'extras', 'price-entry', 'mo-name', 'mo-notes'].forEach(function (cat) {
            MenuObject.patchStyles($mo, {
              type: cat,
              key: 'color',
              value: grayTextColor
            }, false, false);
          })
        }
      } catch (e) {
        console.log(e);
      }

      // this.style.left = `${gutter}%`;

      const newWidth = pageWidth * 0.45;
      this.style.width = `${newWidth}px`;
      $(this).find('.wrapper').css({ 'width': `${newWidth}px` });

      // Set the top position
      // let topPosition = topPositions[panelIndex];
      // if (topPosition + $(this).height() > pageHeight) {
      //   topPosition = pageHeight - $(this).height();
      // }
      // this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      store.dispatch(actions.select($(this)));

      // if (panels > 2) {
      //   MenuObject.setColumns($(this), 1);
      // }
      MenuObject.fixLineHeights($(this), true);

      // Update the top position for the next element in the same panel
      // topPositions[panelIndex] += $(this).height() + topGutter;
    });

    // Frames and Images
    const $framesAndImages = $(this).find(`[data-component="frame"], [data-component="image"]`);
    const widthScalingFactor = pageWidth / util.inchToPixel(oldSize.width);
    // const gutterPx = util.percentToPixel(gutter, pageWidth);
    let currentTopPosition = topGutter;

    $framesAndImages.each(function (i) {
      renderer.unlock($(this));

      const $this = $(this);
      if (this.style.width !== "100%" && this.style.height !== "100%") {
        // Maintain original dimensions
        const originalWidth = $this.width();
        const originalHeight = $this[0].getBoundingClientRect().height;

        // Center horizontally on the page
        const leftPosition = (pageWidth - originalWidth) / 2;
        this.style.left = `${util.pixelToPercent(leftPosition, pageWidth)}%`;

        // Position below the previous image with a gutter
        this.style.top = `${util.pixelToPercent(currentTopPosition, pageHeight)}%`;
        currentTopPosition += originalHeight + gutterPx;
      }
    });

    // Frames and Images (OLD)
    // const $framesAndImages = $(this).find(`[data-component="frame"], [data-component="image"]`);
    // const widthScalingFactor = pageWidth / util.inchToPixel(oldSize.width);

    // $framesAndImages.each(function (i) {
    //   renderer.unlock($(this));

    //   const $this = $(this);
    //   if (this.style.width !== "100%" && this.style.height !== "100%") {
    //     this.style.left = `${gutter}%`;

    //     const originalWidth = $this.width();
    //     const originalHeight = $this.height();
    //     let newWidth = originalWidth * widthScalingFactor;
    //     newWidth = Math.min(newWidth, pageWidth - (gutterPx * 2));
    //     const aspectRatio = originalHeight / originalWidth;
    //     const newHeight = newWidth * aspectRatio;

    //     this.style.width = `${newWidth}px`;
    //     this.style.height = `${newHeight}px`;
    //     $(this).find('.wrapper').css({
    //       'width': `${newWidth}px`,
    //       'height': `${newHeight}px`
    //     });

    //     // Set the top position
    //     // let topPosition = topPositions[panelIndex];
    //     // if (topPosition + $(this).height() > pageHeight) {
    //     //   topPosition = pageHeight - $(this).height();
    //     // }
    //     // this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

    //     // Update the top position for the next element in the same panel
    //     // topPositions[panelIndex] += $(this).height() + topGutter;
    //   }
    // });

    // Shapes
    const $shapes = $(this).find(`[data-component="shape"]`);
    $shapes.each(function (i) {
      renderer.unlock($(this));

      this.style.left = `${gutter}%`;

      // const originalWidth = $(this).width();
      // const originalHeight = $(this).height();
      // let newWidth = originalWidth * widthScalingFactor;
      // newWidth = Math.min(newWidth, panelsWidth - (gutterPx * 2));
      // const aspectRatio = originalHeight / originalWidth;
      // const newHeight = newWidth * aspectRatio;

      // this.style.width = `${newWidth}px`;
      // this.style.height = `${newHeight}px`;
      // $(this).find('.wrapper').css({
      //   'width': `${newWidth}px`,
      //   'height': `${newHeight}px`
      // });
      // $(this).attr("data-px-width", newWidth);

      // Set the top position
      // let topPosition = topPositions[panelIndex];
      // if (topPosition + $(this).height() > pageHeight) {
      //   topPosition = pageHeight - $(this).height();
      // }
      // this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      // Update the top position for the next element in the same panel
      // topPositions[panelIndex] += $(this).height() + topGutter;
    });

    // Illustrations
    const $illustrations = $(this).find(`[data-component="illustration"]`);
    $illustrations.each(function (i) {
      renderer.unlock($(this));

      this.style.left = `${gutter}%`;

      const originalWidth = $(this).width();
      const originalHeight = $(this).height();
      let newWidth = originalWidth * widthScalingFactor;
      newWidth = Math.min(newWidth, pageWidth - (gutterPx * 2));
      const aspectRatio = originalHeight / originalWidth;
      const newHeight = newWidth * aspectRatio;

      this.style.width = `${newWidth}px`;
      this.style.height = `${newHeight}px`;
      $(this).find('.wrapper').css({
        'width': `${newWidth}px`,
        'height': `${newHeight}px`
      });
      $(this).attr("data-px-width", newWidth);

      // Set the top position
      // let topPosition = topPositions[panelIndex];
      // if (topPosition + $(this).height() > pageHeight) {
      // topPosition = pageHeight - $(this).height();
      // }
      // this.style.top = `${util.pixelToPercent(topPosition, pageHeight)}%`;

      // Update the top position for the next element in the same panel
      // topPositions[panelIndex] += $(this).height() + topGutter;
    });

    util.nextTick(() => {
      $components.each(function (i) {
        Interactable.of($(this)).refreshPosition();
      });
    });
  });
}

export function fixPositionScaledResize(size, oldSize) {
  console.log("> fixPositionScaledResize");
  console.log("> size: " + size);
  console.log("> oldSize: " + oldSize);

  menuObject.convertMenuObjectPriceStyles();

  const dims = renderer.getDimensions();

  const widthScaleFactor = (dims.unit === 'px') ? size.width / (constants.oneInchInPoints * 3) / oldSize.width : size.width / oldSize.width;
  const heightScaleFactor = (dims.unit === 'px') ? size.height / (constants.oneInchInPoints * 3) / oldSize.height : size.height / oldSize.height;

  console.log("> widthScaleFactor: " + widthScaleFactor);
  console.log("> heightScaleFactor: " + heightScaleFactor);

  const $components = $(SELECTOR_ALL_COMPONENTS);
  console.log("-> $components.length: " + $components.length);

  $components.each(function () {
    const $this = $(this);
    const componentType = $this.attr('data-component');

    // // Adjust the left and top positions proportionally using percentage
    // const newLeft = parseFloat(this.style.left) * widthScaleFactor;
    // const newTop = parseFloat(this.style.top) * heightScaleFactor;

    // // Apply the new positions using percentage
    // $this.css({
    //   left: `${newLeft}%`,
    //   top: `${newTop}%`
    // });

    // Adjust for specific component types
    switch (componentType) {
      case 'text':
        // Adjust the font size proportionally

        const $p = $(this);
        const originalFontSize = parseInt($p.css('font-size'), 10);
        const newFontSize = originalFontSize * Math.min(widthScaleFactor, heightScaleFactor) * (dims.unit === 'in' ? 10 : 1);

        $p.css('font-size', `${newFontSize}%`);

        setLineHeights($this);

        break;

      case 'image':
      case 'frame':
        if ($this.attr('data-full-page') !== 'true') {
          // Adjust the width and height proportionally
          // const newFrameWidth = $this.width() * widthScaleFactor;
          // const newFrameHeight = $this.height() * heightScaleFactor;

          // $this.css({
          //   width: `${newFrameWidth}px`,
          //   height: `${newFrameHeight}px`
          // });
        }
        // adjustAfterPageResize($this);
        break;

      // if ($this.css('background-image') !== 'none') {
      //   // For background images, keep them at 100% of the canvas
      //   $this.css({
      //     width: '100%',
      //     height: '100%'
      //   });
      // } else {
      //   // Adjust the width and height proportionally
      //   const newWidth = $this.width() * widthScaleFactor;
      //   const newHeight = $this.height() * heightScaleFactor;

      //   $this.css({
      //     width: `${newWidth}px`,
      //     height: `${newHeight}px`
      //   });
      // }
      // break;

      case 'shape':
      case 'illustration':
        // Adjust the width and height proportionally
        // const newShapeWidth = $this.width() * widthScaleFactor;
        // const newShapeHeight = $this.height() * heightScaleFactor;

        // $this.css({
        //   width: `${newShapeWidth}px`,
        //   height: `${newShapeHeight}px`
        // });
        break;

      case 'menu-object':
        const $mo = $(this);

        ['name', 'tag', 'description', 'extras', 'price-entry', 'mo-name', 'mo-notes'].forEach(function (cat) {
          const moStyles = MenuObject.getStyles($mo)[cat];

          if (moStyles) {
            const currentFontSize = moStyles['font-size'] ? parseFloat(moStyles['font-size']) : 100;
            const newFontSize = currentFontSize * widthScaleFactor;

            if (cat === 'price-entry') { 
              cat = 'price-entry:nth-child(1)';
            }

            MenuObject.patchStyles($mo, {
              type: cat,
              key: 'font-size',
              value: `${newFontSize}%`
            }, true, false);
          }
        })

        MenuObject.refreshStyles($mo);

        // const newWidth = $this.width() * widthScaleFactor;
        // this.style.width = `${newWidth}px`;
        // $(this).find('.wrapper').css({ 'width': `${newWidth}px` });

        store.dispatch(actions.select($(this)));
        MenuObject.fixLineHeights($(this), true);
        break;

      case 'qr-code':
        // Adjust the width and height proportionally
        const newQRWidth = $this.width() * widthScaleFactor;
        const newQRHeight = $this.height() * heightScaleFactor;

        $this.css({
          width: `${newQRWidth}px`,
          height: `${newQRHeight}px`
        });
        break;

      default:
        // For other components, adjust width and height proportionally
        const defaultNewWidth = $this.width() * widthScaleFactor;
        const defaultNewHeight = $this.height() * heightScaleFactor;

        $this.css({
          width: `${defaultNewWidth}px`,
          height: `${defaultNewHeight}px`
        });
        break;
    }

    // Adjust wrapper if exists
    $this.find('.wrapper').css({
      width: `${$this.width()}px`,
      height: `${$this.height()}px`
    });
  });

  util.nextTick(() => {
    $components.each(function () {
      Interactable.of($(this)).refreshPosition();
    });
  });
}
